<div class="full-page w-100 d-flex flex-column justify-content-center align-items-center px-0">
  <!--Left Side-->
  <img class="shared-login-banner" draggable="false" alt="logo-desktop" [src]="'logo/logo.svg' | contentAssetImage" />

  <div class="p-3">
    <div class="d-flex w-100 d-md-none m-auto mobile-header"></div>
  </div>
  <!--Right Side-->

  <div class="right-side-login">
    <div class="right-side-container">
      <div
        class="panel-text font-size-14 text-center"
        [innerHTML]="'login.page.description' | translate | markdownTranslate"
      ></div>
      <div class="pt-1">
        <fgb-sports-alliance-user-login></fgb-sports-alliance-user-login>
      </div>
    </div>
  </div>
</div>
